import { ValidationErrorResponse } from "../../../services/ValidationError";
import {ServicioTransporte, ServicioTransporteModificado, TipoTrayectoTransporte} from "../../../services/transporteServicios";
import {parseCurrency} from "../../../utils/numberUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    sector: TextFormValue,
    precio: TextFormValue,
    tipoTrayecto: TextFormValue
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    sector: { value: "", wasTouched: false, isValid: undefined },
    precio: { value: "0", wasTouched: false, isValid: undefined },
    tipoTrayecto: { value: "UN_TRAYECTO", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}

export const servicioTransporteAFormState = (servicio: ServicioTransporte): FormState => {
    return {
        nombre: {value: servicio?.nombre || '', wasTouched: false, isValid: undefined},
        descripcion: {value: servicio?.descripcion || '', wasTouched: false, isValid: undefined},
        sector: {value: servicio?.sector?.id || '', wasTouched: false, isValid: undefined},
        precio: {value: servicio?.precio.toString() || '', wasTouched: false, isValid: undefined},
        tipoTrayecto: {value: servicio?.tipoTrayecto || '', wasTouched: false, isValid: undefined},
    };
}

export const formStateAServicioTransporte = (id: string, formState: FormState): ServicioTransporteModificado => {
    return {
        id,
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        precio: parseCurrency(formState.precio.value, "$", ","),
        idSector: formState.sector.value ? formState.sector.value : undefined,
        tipoTrayecto: formState.tipoTrayecto.value as TipoTrayectoTransporte
    }
}